import { call, put, takeEvery } from 'redux-saga/effects'
import { postLogin } from '../apiRequests/userRequests'
import { types } from '../../types'




function* handlePostLogin(action) {
  try {

    const response = yield call(postLogin, action.params)

    yield put({
      type: types.LOGIN_REQUEST_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.LOGIN_REQUEST_ERROR,
      error: error.response,
    })
  }
}




function* watcherUserSaga() {
  yield takeEvery(types.LOGIN_REQUEST, handlePostLogin)


}

export default watcherUserSaga
